import { useFormikContext } from 'formik';
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import FormInput from '../Form/FormInput';
import { FormLabel } from '../Form/FormLabel';

const ChangeEmail= ({ hide }) => {
    const { values } = useFormikContext();

    return <Container>
        {!hide && <Row>
            <Col>
                <FormLabel>{values.fullName}</FormLabel>
            </Col>
            <Col>
                <FormLabel>{values.email}</FormLabel>
            </Col>
        </Row>}
        <Row>
            <Col>
                <FormInput id='newEmail' label='New Email' type='email' />
            </Col>
        </Row>
      
    </Container>;
}
export default ChangeEmail; 